import React from "react";
import Navbar from "../../components/common/navbar/Navbar";
import ViewExecutive from "../../components/executive/ViewExecutive";

const ViewExecutivePage = () => {
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    {/* Navbar */}
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="VIEW EXECUTIVE" />
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="row">
                        <div className="col-12 p-0">
                            <ViewExecutive />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ViewExecutivePage;
